// 🔧 vendor_seeder.js
// ✅ Purpose: Seeds Vendor Engine demo data into Firestore
// ✅ Features:
// - Coordinates persistence of vendor demo data
// - Calls the repository layer only
// - No Firestore logic in this file
// - No demo data generation
// - Returns standardized results to the Builder
// - Fully block-commented for clarity and future devs

import { saveVendors } from "./vendor_repository";

export const seedVendors = async ({
  demoContext,
  vendorPlan,
} = {}) => {
  console.log("🌱 Vendor Seeder started.");

  if (!vendorPlan) {
    throw new Error(
      "Vendor Seeder requires vendorPlan."
    );
  }

  const results = await saveVendors({
    demoContext,
    vendors: vendorPlan.vendors || [],
  });

  console.log("✅ Vendor Seeder completed.", {
    vendors: results.vendors.length,
  });

  return results;
};